import { useId } from 'react';
import { Text } from '@hangar/web-components/core/Text';
import { caseStatusMapper } from '@/services/api/flightChanges/mappers/statusMapper';
import { mapCaseStatusToPillConfig } from '@/services/api/flightChanges/mappers/mapCaseStatusToPillConfig';
import { useTranslation } from '../../hooks/i18n/useTranslation';
import { StatusChipProps } from './types';
import { StatusPill, StatusPillNeutral } from './StatusChip.styles';

export const StatusChip = ({ status }: StatusChipProps) => {
    const { t } = useTranslation();
    const id = useId();

    const noValidStatusContainer = <Text variant="label-md">-</Text>;

    if (!status) {
        return noValidStatusContainer;
    }

    let mappedStatus;
    try {
        mappedStatus = caseStatusMapper.map(status);
    } catch {
        return noValidStatusContainer;
    }

    if (!mappedStatus) {
        return noValidStatusContainer;
    }

    const pillConfig = mapCaseStatusToPillConfig(mappedStatus);
    const label = t(mappedStatus.toString());

    if (pillConfig.kind === 'baseNeutral') {
        return (
            <StatusPillNeutral id={`case-status-${id}`} role="text">
                {label}
            </StatusPillNeutral>
        );
    }

    return (
        <StatusPill id={`case-status-${id}`} role="text" $tone={pillConfig.tone}>
            {label}
        </StatusPill>
    );
};
